"use strict";

/**
* Кнопка на панели "Создать".
*
* @class WebAccess.components.ActionButton
* @extends BaseObject
* @property {object} _model Модель кнопки панели "Создать"
*/

(function (global) {
  var ActionButton = BaseObject.extend({

    _model: {},
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Конструктор
     * @param {object} model Модель кнопки на панели "Создать"
     * @method WebAccess.components.ActionButton#init
     */
    init: function (model) {
      this._model = model;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак скрытия кнопки на панели "Создать".
     *
     * @method WebAccess.components.ActionButton#isHidden
     * @return {boolean} True, если кнопка скрыта, иначе False.
     */
    isHidden: function () {
      return this._model.hidden;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак отображения кнопки на панели "Создать".
     *
     * @method WebAccess.components.ActionButton#isEnabled
     * @return {boolean} True, если кнопка отображается, иначе False.
     */
    isEnabled: function () {
      return !this._model.disabled;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отображает скрытую кнопку на панели "Создать".
     *
     * @method WebAccess.components.ActionButton#show
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     *
     * @example
     * WebAccess.current.createPanel.buttons['CrtDocTmpl'].show();
     */
    show: function () {
      this._model.hidden = false;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Скрывает кнопку на панели "Создать".
     *
     * @method WebAccess.components.ActionButton#hide
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    hide: function() {
      this._model.hidden = true;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Делает кнопку на панели "Создать" недоступной.
     * Кнопка становится полупрозрачной и не реагирует на события.
     *
     * @method WebAccess.components.ActionButton#disable
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    disable: function() {
      this._model.disabled = true;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Делает кнопку на панели "Создать" доступной.
     *
     * @method WebAccess.components.ActionButton#enable
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    enable: function () {
      this._model.disabled = false;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Добавляет подпись к кнопке на панели "Создать".
     *
     * @param {string} text Текст подписи
     * @method WebAccess.components.ActionButton#setLabel
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    setLabel: function (text) {
      this._model.text = text;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает текст подписи к кнопке на панели "Создать".
     *
     * @method WebAccess.components.ActionButton#getLabel
     * @return {string} Текст подписи к кнопке.
     */
    getLabel: function () {
      return this._model.text;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
     * Устанавливает всплывающую подсказку к кнопке на панели "Создать".
     *
     * @param {string} text Текст всплывающей подсказки
     * @method WebAccess.components.ActionButton#setTooltip
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     * @since 5.0.0.4005
     */
    setTooltip: function (text) {
      this._model.tooltip = text;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает текст всплывающей подсказки к кнопке на панели "Создать".
     *
     * @method WebAccess.components.ActionButton#getTooltip
     * @return {string} Текст всплывающей подсказки.
     * @since 5.0.0.4005
     */
    getTooltip: function () {
      return this._model.tooltip;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Устанавливает иконку для кнопки на панели "Создать".
     *
     * PNG-иконку необходимо разместить в папке App_Sprites корневой папки веб-сайта и после этого опубликовать веб-модуль.
	 * Или можно использовать название SVG-иконки, расположенной в папке svg/icon.
     *
	 * @method WebAccess.components.ActionButton#setIcon
     * @param {string} path Путь к PNG-иконке или название SVG-иконки
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
	 *
	 * @example
     * WebAccess.current.createPanel.buttons['CrtDocTmpl'].setIcon('SidebarAndExtensions/EDocumentSearch_24.png');
     * или
     * WebAccess.current.createPanel.buttons['CrtDocTmpl'].setIcon('task-32');
     */
    setIcon: function (path) {
      this._model.icon = path;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает имя иконки для кнопки на панели "Создать".
     *
     * @method WebAccess.components.ActionButton#getIcon
     * @return {string} Имя иконки.
     */
    getIcon: function() {
      return this._model.icon;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Назначает функцию, выполняемую при нажатии на кнопку на панели "Создать".
     *
     * @method WebAccess.components.ActionButton#click
	 * @param {string} callback Функция, выполняемая при нажатии на кнопку
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    click: function(callback) {
      var instance = this;
      if (callback) {
        this._model.jsaction = callback;
        this._dispatchChangeEvent();
      } else {
        // TODO: сэмулировать клик каким-то образом.
      }
      return this;
    },

    /**
     * Вызвать событие, которое оповещает подписчиков об изменениях в модели кнопки.
     *
     * // Вызванное событие повлечет за собой рендер ExplorerHeader с помощью react (ВД 5.5.0).
     */
    _dispatchChangeEvent: function() {
      this.fire(this['class'].EVENT.CHANGE_STATE);
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  }, {
      /**
       * События.
       */
      EVENT: {
        /**
         * Срабатывает при изменении свойств кнопки на панели "Создать".
         */
        CHANGE_STATE: 'changeState'
      }
    });

  global.ActionButton = ActionButton;

})(window.WebAccess.components);
